export default function sortCellsByXY(data) {
  // Extract cells as an array of objects
  const cells = Object.values(data);

  // Sort cells by y value first, then by x value
  cells.sort((a, b) => (a.y !== b.y ? a.y - b.y : a.x - b.x));

  // Create a sorted object with the same structure as the original data
  const sortedData = {};
  cells.forEach(cell => {
    sortedData[cell.id] = data[cell.id];
  });

  return sortedData;
}
